import Nullstack from 'nullstack';
export default function IconChartGridDots({
  size = 24,
  color = "currentColor",
  stroke = 2
}) {
  const allProps = {
    width: size,
    height: size,
    "stroke-width": stroke,
    stroke: color
  };
  return Nullstack.element("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "inline-flex icon icon-tabler icon-tabler-chart-grid-dots",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    fill: "none",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    ...allProps
  }, "   ", Nullstack.element("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), "   ", Nullstack.element("circle", {
    cx: "18",
    cy: "6",
    r: "2"
  }), "   ", Nullstack.element("circle", {
    cx: "6",
    cy: "12",
    r: "2"
  }), "   ", Nullstack.element("circle", {
    cx: "6",
    cy: "18",
    r: "2"
  }), "   ", Nullstack.element("circle", {
    cx: "18",
    cy: "18",
    r: "2"
  }), "   ", Nullstack.element("path", {
    d: "M8 18h8"
  }), "   ", Nullstack.element("path", {
    d: "M18 20v1"
  }), "   ", Nullstack.element("path", {
    d: "M18 3v1"
  }), "   ", Nullstack.element("path", {
    d: "M6 20v1"
  }), "   ", Nullstack.element("path", {
    d: "M6 10v-7"
  }), "   ", Nullstack.element("path", {
    d: "M12 3v18"
  }), "   ", Nullstack.element("path", {
    d: "M18 8v8"
  }), "   ", Nullstack.element("path", {
    d: "M8 12h13"
  }), "   ", Nullstack.element("path", {
    d: "M21 6h-1"
  }), "   ", Nullstack.element("path", {
    d: "M16 6h-13"
  }), "   ", Nullstack.element("path", {
    d: "M3 12h1"
  }), "   ", Nullstack.element("path", {
    d: "M20 18h1"
  }), "   ", Nullstack.element("path", {
    d: "M3 18h1"
  }), "   ", Nullstack.element("path", {
    d: "M6 14v2"
  }), " ");
}